import urls from 'DjangoUrls';
import axios from 'axios';

let {DjangoUrls} = urls;

function sessionExpireResource() {
    return {
        get_session_status,
        session_prevent_expire,
        logout,
    };

    function get_session_status() {
        const url = DjangoUrls["api.v1:get_session_status"]();
        return axios({
            method: 'GET',
            url
        })
    }

    function session_prevent_expire() {
        const url = DjangoUrls["api.v1:session_prevent_expire"]();
        return axios({
            method: 'GET',
            url
        })
    }

    // a POST, since Django 5 answers a GET logout with 405
    function logout(url) {
        return axios({
            method: 'POST',
            url
        });
    }
}

export default sessionExpireResource;